import { useCallback, useEffect, useState } from 'react';

import { client, useErrorNotifications, useFormErrorHandler } from 'core/http';
import { CustomerSchema } from 'core/schemas/customer';
import { Customer } from 'core/types/customer';

export default function useCustomer(id: string) {
  const handleFormErrors = useFormErrorHandler();
  const showErrorNotification = useErrorNotifications();
  const [customer, setCustomer] = useState<Customer>();

  useEffect(() => {
    client()
      .get<Customer>(`customers/${id}`)
      .then(response => response.data)
      .then(setCustomer)
      .catch(showErrorNotification);
  }, [showErrorNotification, id]);

  const update = useCallback(
    (payload: CustomerSchema) => {
      return client()
        .patch<Customer>(`customers/${id}`, payload)
        .then(response => response.data)
        .then(setCustomer)
        .catch(handleFormErrors);
    },
    [id, handleFormErrors]
  );

  return { customer, update };
}
